import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const sqliteUtcTimestampPattern = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(?:\.\d+)?$/;

export function parseTimestamp(dateString: string): Date {
  if (sqliteUtcTimestampPattern.test(dateString)) {
    return new Date(`${dateString.replace(' ', 'T')}Z`);
  }

  return new Date(dateString);
}

export function getTimestampMs(dateString: string): number {
  return parseTimestamp(dateString).getTime();
}

export function formatRelativeTime(dateString: string, now = new Date()): string {
  const date = parseTimestamp(dateString);
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 60) {
    return 'Gerade eben';
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `vor ${diffInMinutes} Min.`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `vor ${diffInHours} Std.`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) {
    return `vor ${diffInDays} ${diffInDays === 1 ? 'Tag' : 'Tagen'}`;
  }

  return date.toLocaleDateString('de-DE', {
    day: 'numeric',
    month: 'short',
  });
}

export function formatDate(dateString: string): string {
  const date = parseTimestamp(dateString);
  return date.toLocaleDateString('de-DE', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
